import makeRequest from '../makeRequest';
import { BASE_URL } from '../environment';

export async function createCognitoUser(userData) {
  return makeRequest(`${BASE_URL}/admincreateuser`, {
    method: 'POST',
    body: JSON.stringify(userData),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function addPartner(partnerData) {
  return makeRequest(`${BASE_URL}/adminaddpartner`, {
    method: 'POST',
    body: JSON.stringify(partnerData),
    headers: { 'Content-Type': 'application/json' },
  });
}
